<div class="alert alert-warning alert-dismissible p-2 m-0" role="alert">
    <div class="row p-0 m-0">
        <div class="col-1 d-flex align-items-center justify-content-center p-0 mr-1">
            <i class="bi bi-exclamation-triangle" style="font-size: 21px; color: #ff9f43;"></i>
        </div>
        <div class="col p-0 m-0">
           <div class="row">
            <div class="col p-0 m-0">
                <span style="font-size: 12px;">{{ alertData.message }}</span>
            </div>
           </div>
        </div>
      </div>
</div>